export const OPEN_ADD_WHD_FORM_MODAL = 'OPEN_ADD_WHD_FORM_MODAL';
export const CLOSE_ADD_WHD_FORM_MODAL = 'CLOSE_ADD_WHD_FORM_MODAL';

function openAddWhdFormModal() {
  return {
    type: OPEN_ADD_WHD_FORM_MODAL,
    isAddWhdCalcModalShown: true
  };
}

function closeAddWhdFormModal() {
  return {
    type: CLOSE_ADD_WHD_FORM_MODAL,
    isAddWhdCalcModalShown: false,
    isAddingWhdForm: false,
    addingWhdFormError: null
  };
}

export function showAddWhdFormModal() {
  return (dispatch) => {
    dispatch(openAddWhdFormModal());
  };
}

export function hideAddWhdFormModal() {
  return (dispatch) => {
    dispatch(closeAddWhdFormModal());
  };
}
